import React, {useState, useEffect, useCallback} from 'react';
import {EVENT_ID, subscribe, unsubscribe, dispatch} from '../../../../containers/event_manager';
import {Toast} from 'web-components';
import Styled from 'styled-components/macro';

const ToastWrapperStyled = Styled.div`
	z-index: 999;
	position: fixed;
	left: 24px;
	bottom: 24px;	
	transition:height 1s ease;
`;

export const createToast = props => {
	dispatch(EVENT_ID.SHOW_TOAST, props);
};

export const ToastWrapper = ({actionCallback, actionText, duration, message}) => {
	const [toasts, setToasts] = useState([]);

	const addToast = useCallback(
		toast => {
			setToasts(toasts => [...toasts, toast]);
		},
		[setToasts]
	);

	useEffect(() => {
		subscribe(EVENT_ID.SHOW_TOAST, toast => addToast(toast));
		return () => {
			unsubscribe(EVENT_ID.SHOW_TOAST, addToast);
		};
	}, []);

	useEffect(() => {
		if (toasts.length > 0) {
			const timer = setTimeout(() => setToasts(toasts => toasts.slice(1)), 2000);
			return () => clearTimeout(timer);
		}
	}, [toasts]);

	return (
		<ToastWrapperStyled className="toaster">
			{toasts.map(toast => {
				return <Toast coreText={toast.message}></Toast>;
			})}
		</ToastWrapperStyled>
	);
};
